import type { FC } from 'react'

import { useEffect } from 'react'
import { useRouter } from 'next/router'
import { setSmoothScroller } from '@/lib/smooth-scroll'

/** Site-wide inertial scrolling. Off for reduced motion and on touch screens, which keep native scrolling. */
export const SmoothScroll: FC = () => {
    const router = useRouter()

    useEffect(() => {
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

        let cancelled = false
        let destroy: (() => void) | null = null

        import('lenis').then(({ default: Lenis }) => {
            if (cancelled) return

            const lenis = new Lenis({
                autoRaf: true,
                lerp: 0.09,
                wheelMultiplier: 0.95,
                anchors: { offset: -88 }
            })

            setSmoothScroller(lenis)

            const handleStart = () => lenis.stop()
            const handleDone = () => {
                lenis.start()
                lenis.resize()
            }

            router.events.on('routeChangeStart', handleStart)
            router.events.on('routeChangeComplete', handleDone)
            router.events.on('routeChangeError', handleDone)

            destroy = () => {
                router.events.off('routeChangeStart', handleStart)
                router.events.off('routeChangeComplete', handleDone)
                router.events.off('routeChangeError', handleDone)
                setSmoothScroller(null)
                lenis.destroy()
            }
        }).catch(() => undefined)

        return () => {
            cancelled = true
            destroy?.()
        }
    }, [router.events])

    return null
}
